module.exports = __webpack_public_path__ + "static/d3-184159525d065c39a2f736201f287706.png";